// Floating "show my location" button. One press asks the browser for a fresh
// position and draws a dot; the dot clears itself ten minutes later. Not part of
// the toolbar, so it stays reachable when the toolbar is collapsed or locked.

// @deno-types="npm:@types/mithril@^2.2.7"
import m from "mithril";
import { ui } from "../ui.ts";
import { LOCATION_TTL_MS, locate } from "./map/locate.ts";
import { DOM_ATTRIBUTE } from "./dom-attributes.ts";

function label(): string {
  switch (ui.locationStatus) {
    case "locating":
      return "Finding your location…";
    case "active":
      return "Update my location (clears after 10 minutes)";
    case "error":
      return ui.locationMessage || "Location unavailable";
    default:
      return "Show my location";
  }
}

export function LocateButton(): m.Component {
  return {
    view() {
      const status = ui.locationStatus;
      const glyph = status === "locating"
        ? "fa fa-spinner fa-spin"
        : "fa fa-crosshairs";
      return m("button#locate-button", {
        type: "button",
        title: label(),
        "aria-label": label(),
        "aria-busy": status === "locating" ? "true" : "false",
        [DOM_ATTRIBUTE.action]: "locate",
        "data-status": status,
        "data-ttl": String(LOCATION_TTL_MS),
        onclick: locate,
      }, m("i", { class: glyph }));
    },
  };
}
